import BreadCrumbs from './ProcessComponents/BreadCrumbs';
import { useCallback, useEffect, useState } from 'react';
import { Box, Grid, IconButton, useMediaQuery } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import moment from 'moment';
import { CmpButtonWithIcon, CmpTypographyField } from '../../component/ToolBox/ToolBox';
import { useSelector } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';
import { Refresh } from '@mui/icons-material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { ItemListVanModal } from './ProcessComponents/ItemListVanModal';
import { distributionSummaryApi } from '../Purchase/actions';
import DistributionItemListDrawer from './DistributionItemListDrawer';

export default function DistributionSummary() {
  const rdxuser = useSelector((state) => state.SliceDB.value.login);

  const rdxFilterObj = useSelector((state) => state.layoutSlice.filter);
  const locList = useSelector((state) => state.SliceDB.value.getLocation);
  const dcLoclist = useSelector((state) => state.SliceDB.value.getDCLocation);

  const vMediaQuery = useMediaQuery('(max-width: 900px)');

  const [sFilteredLocNames, setFilteredLocNames] = useState([]);
  const [sFilteredDCNames, setFilteredDCNames] = useState([]);
  const [sRows, setRows] = useState([]);

  const [openVanModal, setOpenVanModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);

  const fSummary = async () => {
    const obj = {
      fromDate: moment(rdxFilterObj.dateFrom).format('MM/DD/YYYY'),
      toDate: moment(rdxFilterObj.dateTo).format('MM/DD/YYYY'),
      userCd: rdxuser.userId,
      locList: rdxFilterObj.DCList.toString()
    };
    const result = await distributionSummaryApi(obj);
    console.log(result);

    if (result?.ResultSet?.length > 0) {
      setRows(result.ResultSet);
    } else {
      setRows([]);
    }
    return result.ResultSet;
  };

  const fOnPageLoad = useCallback(async () => {
    let filteredDC = dcLoclist.filter((i) => rdxFilterObj.DCList.includes(i.UId));
    setFilteredDCNames(filteredDC.map((i) => i.Name1));

    let filteredLoc = locList.filter((i) => rdxFilterObj.locList.includes(i.UId));
    setFilteredLocNames(filteredLoc.map((i) => i.Name1));

    await fSummary();
  }, [rdxFilterObj, locList, dcLoclist]);

  const fOnpressLoad = async () => {
    await fSummary();
  };
  useEffect(() => {
    fOnPageLoad();
  }, [fOnPageLoad]);

  const handleRowClick = (params, event) => {
    event.stopPropagation(); // optional; keeps things tidy
    setSelectedRow(params.row);
    setOpenDrawer(true);
  };

  // van icon click -> open modal (and NOT the drawer)
  const handleVanClick = (e, row) => {
    e.stopPropagation(); // <-- prevents row click from firing
    setSelectedRow(row);
    setOpenVanModal(true);
  };
  const handleVanClose = () => {
    setOpenVanModal(false);
    setSelectedRow(null);
  };

  const gridColumns = [
    {
      field: 'VocName',
      headerName: 'Doc.Type',
      // flex: 3,
      width: vMediaQuery ? 150 : 200
    },

    {
      field: 'A_VocNo',
      headerName: 'Doc.No',
      // flex: 2
      width: vMediaQuery ? 150 : 105
    },

    {
      field: 'A_VocDt',
      headerName: 'Date',
      // flex: 1.5,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: ({ value }) => moment(value).format('DD/MM/YYYY'),
      width: vMediaQuery ? 90 : 100
    },
    {
      field: 'LocName',
      headerName: 'Location',
      // flex: 2
      width: vMediaQuery ? 120 : 110
    },
    {
      field: 'TruckName',
      headerName: 'Truck',
      // flex: 2
      width: vMediaQuery ? 120 : 100
    },
    {
      field: 'A_DocStat',
      headerName: 'Status',
      // flex: 2
      align: 'center',
      headerAlign: 'center',
      width: 90
    },
    {
      field: 'isDistributed',
      headerName: 'Distributed',
      // flex: 2
      width: vMediaQuery ? 90 : 100,
      align: 'center',
      headerAlign: 'center'
    },
    {
      field: 'TruckStatus',
      headerName: 'Truck.Status',
      align: 'center',
      headerAlign: 'center',
      width: vMediaQuery ? 120 : 100,
      valueGetter: (params) => (params.row.TruckStatus ? 'Y' : 'N')
    }
  ];
  return (
    <div className="container">
      <div
      // className="my-2"
      >
        <BreadCrumbs />
      </div>
      <div>
        <ToastContainer />
      </div>
      <Box sx={{ flexGrow: 1 }}>
        <Grid
          container
          spacing={1}
          columnSpacing={2}
          columns={{ xs: 12, sm: 12, md: 12 }}
          sx={{ alignItems: 'center' }}
          className="mb-2">
          <Grid item xs={12} sm={12} md={12}>
            <Grid
              container
              spacing={1}
              columns={{ xs: 12, sm: 12, md: 12 }}
              sx={{ alignItems: 'center' }}>
              <Grid item xs={2.2} sm={1.5} md={1.1}>
                <CmpTypographyField xcomponent={'span'} xText={'Location'} />
              </Grid>
              <Grid item xs={0.5} sm={0.3} md={0.3}>
                <CmpTypographyField xcomponent={'span'} xText={':'} />
              </Grid>

              <Grid item xs={9.3} sm={10} md={10.6}>
                <CmpTypographyField xcomponent={'span'} xText={sFilteredDCNames.toString()} />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={6} sm={4} md={3}>
            <Grid
              container
              spacing={1}
              columns={{ xs: 12, sm: 12, md: 12 }}
              sx={{ alignItems: 'center' }}>
              <Grid item xs={4.5} sm={4.55} md={4.6}>
                <CmpTypographyField xcomponent={'span'} xText={'From Date'} />
              </Grid>
              <Grid item xs={1} sm={1} md={1}>
                <CmpTypographyField xcomponent={'span'} xText={':'} />
              </Grid>
              <Grid item xs={4.5} sm={5.95} md={6.4}>
                <CmpTypographyField
                  xcomponent={'span'}
                  xText={moment(rdxFilterObj.dateFrom).format('DD/MM/YYYY')}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6} sm={4} md={3}>
            <Grid
              container
              spacing={1}
              columns={{ xs: 12, sm: 12, md: 12 }}
              sx={{ alignItems: 'center' }}>
              <Grid item xs={3.5} sm={4.05} md={4}>
                <CmpTypographyField xcomponent={'span'} xText={'To Date'} />
              </Grid>
              <Grid item xs={1} sm={1} md={1}>
                <CmpTypographyField xcomponent={'span'} xText={':'} />
              </Grid>
              <Grid item xs={4.5} sm={5.95} md={7}>
                <CmpTypographyField
                  xcomponent={'span'}
                  xText={moment(rdxFilterObj.dateTo).format('DD/MM/YYYY')}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={4} md={6}>
            <Grid
              container
              spacing={0}
              columns={{ xs: 12, sm: 12, md: 12 }}
              sx={{
                display: 'flex',
                justifyContent: 'end',
                alignItems: 'center'
              }}>
              <Grid item xs={3} sm={4.5} md={2}>
                <CmpButtonWithIcon
                  xvariant={'contained'}
                  xsize={'small'}
                  xonClick={() => fOnpressLoad()}
                  xLabel={'Load'}
                  xIcon={<Refresh />}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box
          width="100%"
          sx={{
            height: vMediaQuery ? '65vh' : '75vh',
            width: '100%',
            '& .actions': {
              color: 'text.secondary'
            },
            '& .textPrimary': {
              color: 'text.primary'
            },
            '& .Mui-error': {
              backgroundColor: `rgb(126,10,15, 0.1})`,
              color: '#ff4343'
            }
          }}>
          <DataGrid
            rows={sRows}
            getRowId={(row) => row.A_VocNo}
            columns={gridColumns}
            rowHeight={32}
            headerHeight={35}
            sx={{
              border: 2,
              borderColor: 'primary.light',
              border: 1,
              borderColor: 'primary.light',
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#0d73bb',
                color: 'white'
              }
            }}
            componentsProps={{
              filterPanel: { sx: { maxWidth: '93vw' } }
            }}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? 'mui-even-row' : 'mui-odd-row'
            }
            onRowClick={handleRowClick}
          />
        </Box>
        <ItemListVanModal open={openVanModal} onClose={handleVanClose} data={selectedRow} />
      </Box>

      <DistributionItemListDrawer
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        data={selectedRow}
        setSelectedRow={setSelectedRow}
        fOnPageLoad={fOnPageLoad}
      />
    </div>
  );
}
